<template>
  <div id="individual-display-data" class="create-dialog-container">
    <v-card class="create-dialog-card elevation-24">
      <!-- Professional Header -->
      <div class="create-dialog-header">
        <div class="header-left">
          <v-icon size="36" color="white" class="header-icon-badge"
            >mdi-plus-circle</v-icon
          >
          <div class="header-text-section">
            <h2 class="header-title">{{ pageTitle }}</h2>
            <p class="header-subtitle">
              Add a new event plan with details and pricing
            </p>
          </div>
        </div>
        <div class="header-right">
          <v-btn
            icon
            dark
            @click="closePrompt"
            class="header-action-btn"
            v-tooltip.left="'Close'"
          >
            <v-icon size="24">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- Content Area -->
      <v-sheet
        id="scrolling-techniques-7"
        class="create-dialog-content-sheet overflow-y-auto"
        max-height="600"
      >
        <v-card-text class="create-dialog-body-content">
          <!-- Loading State -->
          <div v-if="LoadingFlag" class="text-center py-12">
            <v-progress-circular
              :size="70"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <p class="mt-6 text-h6 primary--text font-weight-600">
              Creating plan...
            </p>
          </div>

          <!-- Form Content -->
          <div v-if="!LoadingFlag">
            <div class="form-helper-text">
              <v-icon small color="primary" class="mr-2"
                >mdi-information-outline</v-icon
              >
              <span
                ><span class="text-danger">*</span> indicates required
                field</span
              >
            </div>

            <v-form ref="form1" v-model="valid1" lazy-validation>
              <v-row wrap class="form-fields-grid">
                <!-- From Date -->
                <v-col cols="12" sm="6" md="4">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-calendar-start</v-icon
                      >
                      <span><span class="text-danger">*</span> From Date</span>
                    </label>
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          required
                          v-model="FromDate"
                          label="Select date"
                          hint="Event start date"
                          persistent-hint
                          readonly
                          v-on="on"
                          class="form-control-modern"
                          solo
                          dense
                          outlined
                          prefix="📅"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="FromDate"
                        @input="menu1 = false"
                        color="primary"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-col>

                <!-- To Date -->
                <v-col cols="12" sm="6" md="4">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-calendar-end</v-icon
                      >
                      <span><span class="text-danger">*</span> To Date</span>
                    </label>
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          required
                          v-model="ToDate"
                          label="Select date"
                          hint="Event end date"
                          persistent-hint
                          readonly
                          v-on="on"
                          class="form-control-modern"
                          solo
                          dense
                          outlined
                          prefix="📅"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="ToDate"
                        @input="menu2 = false"
                        color="primary"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-col>

                <!-- Plan Name -->
                <v-col cols="12" sm="6" md="4">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-tag-text</v-icon
                      >
                      <span><span class="text-danger">*</span> Plan Name</span>
                    </label>
                    <v-text-field
                      v-model="PlanName"
                      :rules="PlanNameRules"
                      label="Enter plan name"
                      hint="e.g., Silver Plan, Gold Plan"
                      persistent-hint
                      class="form-control-modern"
                      outlined
                      dense
                      solo
                    ></v-text-field>
                  </div>
                </v-col>

                <!-- Max Registration Count -->
                <v-col cols="12" sm="6" md="4">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-account-multiple</v-icon
                      >
                      <span
                        ><span class="text-danger">*</span> Max
                        Registration</span
                      >
                    </label>
                    <v-text-field
                      v-model="MaxRegistrationCount"
                      :rules="MaxRegistrationCountRules"
                      label="0 for unlimited"
                      hint="Maximum participants allowed"
                      persistent-hint
                      class="form-control-modern"
                      outlined
                      dense
                      solo
                      type="number"
                    ></v-text-field>
                  </div>
                </v-col>

                <!-- Order By -->
                <v-col cols="12" sm="6" md="4">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-sort-numeric</v-icon
                      >
                      <span><span class="text-danger">*</span> Order By</span>
                    </label>
                    <v-text-field
                      v-model="OrderBy"
                      :rules="OrderByRules"
                      label="Display order"
                      hint="Sorting priority (1, 2, 3...)"
                      persistent-hint
                      class="form-control-modern"
                      outlined
                      dense
                      solo
                      type="number"
                    ></v-text-field>
                  </div>
                </v-col>

                <!-- Featured Plan Switch -->
                <v-col cols="12" sm="6" md="4">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-star</v-icon
                      >
                      <span
                        ><span class="text-danger">*</span> Featured Plan?</span
                      >
                    </label>
                    <v-switch
                      v-model="Recommended"
                      :label="`${Recommended == 1 ? 'Yes' : 'No'}`"
                      class="form-switch-modern"
                    ></v-switch>
                  </div>
                </v-col>

                <!-- Free Plan Switch -->
                <v-col cols="12" sm="6" md="4">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-gift</v-icon
                      >
                      <span><span class="text-danger">*</span> Free Plan?</span>
                    </label>
                    <v-switch
                      v-model="FreePlan"
                      :label="`${FreePlan == 1 ? 'Yes' : 'No'}`"
                      class="form-switch-modern"
                    ></v-switch>
                  </div>
                </v-col>

                <!-- Active Status Switch -->
                <v-col cols="12" sm="6" md="4">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-toggle-switch</v-icon
                      >
                      <span
                        ><span class="text-danger">*</span> Active Status</span
                      >
                    </label>
                    <v-switch
                      v-model="ActiveStatus"
                      :label="`${ActiveStatus == 1 ? 'Active' : 'Inactive'}`"
                      class="form-switch-modern"
                    ></v-switch>
                  </div>
                </v-col>

                <!-- Sub Total (Conditional) -->
                <v-col cols="12" sm="6" md="4" v-if="FreePlan == 0">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-currency-usd</v-icon
                      >
                      <span><span class="text-danger">*</span> Sub Total</span>
                    </label>
                    <v-text-field
                      @input="calculateTotalAmount"
                      v-model="SubTotal"
                      :rules="SubTotalRules"
                      label="Enter amount"
                      hint="Base price without tax"
                      persistent-hint
                      class="form-control-modern"
                      outlined
                      dense
                      solo
                      type="number"
                      prefix="₹"
                    ></v-text-field>
                  </div>
                </v-col>

                <!-- Tax (Conditional) -->
                <v-col cols="12" sm="6" md="4" v-if="FreePlan == 0">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-percent</v-icon
                      >
                      <span><span class="text-danger">*</span> Tax (%)</span>
                    </label>
                    <v-text-field
                      @input="calculateTotalAmount"
                      v-model="Tax"
                      :rules="TaxRules"
                      label="Enter tax percentage"
                      hint="Tax percentage (0-100)"
                      persistent-hint
                      class="form-control-modern"
                      outlined
                      dense
                      solo
                      type="number"
                    ></v-text-field>
                  </div>
                </v-col>

                <!-- Total Amount Display (Conditional) -->
                <v-col cols="12" sm="6" md="4" v-if="FreePlan == 0">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="success"
                        >mdi-calculator</v-icon
                      >
                      <span>Total Amount</span>
                    </label>
                    <v-card class="total-amount-display" elevation="4">
                      <v-card-text class="text-center pa-4">
                        <h3 class="total-amount-value">₹{{ TotalAmount }}</h3>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-col>

                <!-- Content Editor -->
                <v-col cols="12" md="12">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-file-document-edit</v-icon
                      >
                      <span
                        >Content
                        <small class="text-grey-1">(optional)</small></span
                      >
                    </label>
                    <v-card class="editor-wrapper elevation-2" outlined>
                      <ckeditor
                        v-model="Content"
                        :config="editorConfig"
                      ></ckeditor>
                    </v-card>
                  </div>
                </v-col>
              </v-row>

              <!-- Action Buttons -->
              <v-row wrap class="form-actions-row mt-6">
                <v-col align="center" cols="12" md="12">
                  <v-btn
                    @click="closePrompt"
                    color="grey"
                    elevation="4"
                    rounded
                    height="48"
                    min-width="160"
                    class="cancel-btn"
                  >
                    <v-icon left>mdi-close</v-icon>
                    CANCEL
                  </v-btn>
                  <v-btn
                    :disabled="!valid1"
                    @click.prevent="submitForm"
                    :loading="LoadingFlag"
                    color="#667eea"
                    elevation="6"
                    rounded
                    height="48"
                    min-width="160"
                    class="submit-btn white--text mr-3"
                  >
                    <v-icon left>mdi-check-circle</v-icon>
                    SUBMIT
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-sheet>

      <!-- Footer -->
      <v-divider></v-divider>
      <v-card-actions class="create-dialog-footer pa-4">
        <v-spacer />
        <p class="text-caption text-grey-1">
          All fields marked with <span class="text-danger">*</span> are required
        </p>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import ckEditorConfig from "@/ckeditor_config.json";

export default {
  mixins: [common],
  props: {
    record: {
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      pageTitle: "Events Plan Create",

      LoadingFlag: false,
      ResultFlag: false,

      FromDate: "",
      FromDateRules: [(v) => !!v || "From date is required"],
      menu1: false,

      ToDate: "",
      ToDateRules: [(v) => !!v || "To date is required"],
      menu2: false,

      PlanName: "",
      PlanNameRules: [(v) => !!v || "Plan name is required"],

      MaxRegistrationCount: "",
      MaxRegistrationCountRules: [
        (v) => !!v || "Max registration count is required",
      ],

      Recommended: 0,
      FreePlan: 0,
      ActiveStatus: 1,

      SubTotal: "",
      SubTotalRules: [(v) => !!v || "Sub total is required"],

      Tax: "",
      TaxRules: [(v) => !!v || "Tax is required"],

      TotalAmount: "",

      OrderBy: 1,
      OrderByRules: [(v) => !!v || "Ordr By is required"],

      editorConfig: ckEditorConfig,

      Content: "",
      ContentRules: [
        // (v) => !!v || "Active status is required"
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.initialize()
  },
  methods: {
    resetForm() {
      this.$refs.form1.reset();
      this.FromDate = "";
      this.ToDate = "";
      this.Content = "";
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog", this.ResultFlag);
    },
    refreshPageData() {
      console.log("refreshPageData called");
    },
    calculateTotalAmount() {
      console.log("calculateTotalAmount called");
      var SubTotal = this.SubTotal;
      SubTotal = isNaN(SubTotal) ? 0 : SubTotal;
      var Tax = parseFloat(this.Tax);
      Tax = isNaN(Tax) ? 0 : Tax;
      console.log("SubTotal=" + SubTotal + ", Tax" + Tax);

      var TaxAmount = (SubTotal * Tax) / 100;
      console.log({ TaxAmount });

      var TotalAmount = parseFloat(SubTotal) + parseFloat(TaxAmount);
      console.log({ TotalAmount });
      this.TotalAmount = isNaN(TotalAmount) ? 0 : TotalAmount;
    },
    submitForm() {
      console.log("submitForm is called");
      var validate1 = this.$refs.form1.validate();
      console.log({ validate1 });
      var tr = this.record;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      var FromDate = this.FromDate;
      var ToDate = this.ToDate;

      if (n1 > 0 && validate1 && FromDate != "" && ToDate != "") {
        this.LoadingFlag = true;
        this.ResultFlag = false;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-program/plan/store";
        var upload = {
          UserInterface: 1,
          Event: tr.ProgramId,
          FromDate: this.FromDate,
          ToDate: this.ToDate,
          PlanName: this.PlanName,
          MaxRegistrationCount: this.MaxRegistrationCount,
          Recommended: this.Recommended,
          FreePlan: this.FreePlan,
          SubTotal: this.SubTotal,
          Tax: this.Tax,
          TotalAmount: this.TotalAmount,
          OrderBy: this.OrderBy,
          ActiveStatus: this.ActiveStatus,
          Content: this.Content,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.closePrompt();
              thisIns.sweetAlert("success", output, true);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "";
        if (n1 == 0) {
          message += "Event details not found. ";
        }
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (FromDate == "") {
          message += "From Date should not be empty. ";
        }
        if (ToDate == "") {
          message += "To Date should not be empty. ";
        }
        // this.toast("error", message);
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.create-dialog-container {
  width: 100%;
  height: 100%;
}

/* ============================================
   DIALOG CARD
   ============================================ */
.create-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  animation: dialogSlideIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 95vh;
  display: flex;
  flex-direction: column;
}

/* ============================================
   DIALOG HEADER
   ============================================ */
.create-dialog-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px 28px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    animation: rotate 20s linear infinite;
  }

  .header-left {
    display: flex;
    align-items: center;
    z-index: 1;
    animation: slideInLeft 0.6s ease-out;
    gap: 16px;
  }

  .header-icon-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.2);
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    animation: pulse 2s ease-in-out infinite;
  }

  .header-text-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .header-right {
    display: flex;
    gap: 8px;
    z-index: 1;
  }

  .header-title {
    font-size: 1.35rem;
    font-weight: 800;
    margin: 0;
    letter-spacing: 0.5px;
    line-height: 1.2;
    color: white;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .header-subtitle {
    font-size: 0.8rem;
    opacity: 0.92;
    margin: 6px 0 0 0;
    font-weight: 500;
    letter-spacing: 0.2px;
    color: rgba(255, 255, 255, 0.95);
  }
}

.header-action-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

  &:hover {
    transform: scale(1.15) !important;
    background: rgba(255, 255, 255, 0.2) !important;
  }

  &:active {
    transform: scale(0.95) !important;
  }
}

/* ============================================
   DIALOG CONTENT
   ============================================ */
.create-dialog-content-sheet {
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%) !important;
  padding: 0 !important;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(102, 126, 234, 0.05);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(102, 126, 234, 0.3);
    border-radius: 10px;

    &:hover {
      background: rgba(102, 126, 234, 0.5);
    }
  }
}

.create-dialog-body-content {
  padding: 28px !important;
  animation: fadeIn 0.6s ease-out 0.2s both;
}

/* ============================================
   FORM HELPER TEXT
   ============================================ */
.form-helper-text {
  display: flex;
  align-items: center;
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.08) 0%,
    rgba(118, 75, 162, 0.08) 100%
  );
  border-left: 4px solid #667eea;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

/* ============================================
   FORM FIELDS
   ============================================ */
.form-fields-grid {
  margin-bottom: 20px;
}

.form-field-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-field-label {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  color: #333;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin: 0;

  .v-icon {
    color: #667eea;
  }

  .text-danger {
    color: #e74c3c;
    font-weight: 800;
  }
}

/* ============================================
   FORM CONTROLS
   ============================================ */
.form-control-modern {
  ::v-deep {
    .v-input__control {
      .v-input__slot {
        background: white !important;
        border-radius: 8px !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 1px solid rgba(102, 126, 234, 0.2) !important;

        &:hover {
          border-color: rgba(102, 126, 234, 0.4) !important;
        }

        &:focus,
        &:active {
          border-color: #667eea !important;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }
      }

      .v-input__append-inner {
        .v-icon {
          color: #667eea !important;
          font-size: 18px !important;
        }
      }
    }

    .v-text-field__prefix {
      color: #667eea !important;
      font-weight: 700;
      margin-right: 8px;
    }

    .v-input__hint {
      color: #999 !important;
      font-size: 12px !important;
    }

    &.v-text-field--outlined {
      .v-input__control {
        .v-input__slot {
          background: white !important;
          border: 1px solid rgba(102, 126, 234, 0.2) !important;

          input {
            color: #333;
            font-weight: 500;
          }
        }
      }
    }
  }
}

/* ============================================
   FORM SWITCHES
   ============================================ */
.form-switch-modern {
  ::v-deep {
    .v-input__control {
      .v-input__slot {
        margin-top: 12px;
      }

      .v-switch__track {
        background: rgba(102, 126, 234, 0.3) !important;
      }

      .v-switch__thumb {
        background: white !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      .v-input--is-focused {
        .v-switch__track {
          background: #667eea !important;
        }
      }
    }

    .v-label {
      color: #333 !important;
      font-weight: 600;
    }
  }
}

/* ============================================
   TOTAL AMOUNT DISPLAY
   ============================================ */
.total-amount-display {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.05) 0%,
    rgba(118, 75, 162, 0.05) 100%
  ) !important;
  border: 2px solid rgba(102, 126, 234, 0.2) !important;
  border-radius: 12px !important;
  margin-top: 12px;

  .total-amount-value {
    color: #667eea;
    font-weight: 800;
    font-size: 28px;
    margin: 0;
    text-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);
  }
}

/* ============================================
   EDITOR WRAPPER
   ============================================ */
.editor-wrapper {
  border-radius: 8px !important;
  border: 1px solid rgba(102, 126, 234, 0.15) !important;
  overflow: hidden;
  margin-top: 12px;

  ::v-deep {
    .ck-editor__main {
      border-radius: 8px;

      .ck-content {
        min-height: 250px;
        color: #333;
        font-size: 14px;
        line-height: 1.8;

        &:focus {
          outline: none;
        }
      }
    }

    .ck-toolbar {
      background: linear-gradient(90deg, #f9fafb 0%, #ffffff 100%);
      border-bottom: 1px solid rgba(102, 126, 234, 0.15);
      border-radius: 0;
      padding: 8px;

      .ck-toolbar__items {
        gap: 4px;
      }

      .ck-button {
        &:hover {
          background: rgba(102, 126, 234, 0.1);
        }

        &.ck-on {
          background: rgba(102, 126, 234, 0.2);
          color: #667eea;
        }
      }
    }
  }
}

/* ============================================
   ACTION BUTTONS
   ============================================ */
.form-actions-row {
  padding-top: 16px;
  border-top: 1px solid rgba(102, 126, 234, 0.1);
}

.submit-btn {
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.25) !important;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4) !important;
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.cancel-btn {
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;

  &:hover {
    transform: translateY(-2px);
    background: #f0f0f0 !important;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15) !important;
  }

  &:active {
    transform: translateY(0);
  }
}

/* ============================================
   DIALOG FOOTER
   ============================================ */
.create-dialog-footer {
  background: linear-gradient(90deg, #f9fafb 0%, #ffffff 100%);
  border-top: 1px solid rgba(102, 126, 234, 0.1);
  padding: 12px 24px !important;

  p {
    margin: 0;
    color: #666;
  }
}

/* ============================================
   ANIMATIONS
   ============================================ */
@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  50% {
    box-shadow: 0 4px 20px rgba(255, 255, 255, 0.3);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */
@media (max-width: 960px) {
  .create-dialog-header {
    flex-direction: column;
    text-align: center;
    align-items: center !important;

    .header-left {
      justify-content: center;
      margin-bottom: 12px;
    }

    .header-right {
      width: 100%;
      justify-content: flex-end;
    }

    .header-title {
      font-size: 1.1rem;
    }

    .header-subtitle {
      font-size: 0.75rem;
    }
  }

  .create-dialog-body-content {
    padding: 20px !important;
  }

  .form-fields-grid {
    row-gap: 16px;
  }
}

@media (max-width: 600px) {
  .create-dialog-card {
    max-height: 97vh;
    max-width: 98vw;
  }

  .create-dialog-header {
    padding: 16px !important;

    .header-left {
      flex-direction: column;
      text-align: center;
    }

    .header-icon-badge {
      width: 48px;
      height: 48px;
    }

    .header-title {
      font-size: 1rem;
    }

    .header-subtitle {
      display: none;
    }

    .header-right {
      margin-top: 12px;
    }
  }

  .create-dialog-body-content {
    padding: 16px !important;
  }

  .form-field-label {
    font-size: 12px;
  }

  .submit-btn,
  .cancel-btn {
    width: 100%;
    margin-bottom: 8px !important;
  }

  .form-actions-row {
    .v-col {
      flex-direction: column;
    }
  }
}

/* ============================================
   ADDITIONAL STYLING
   ============================================ */
::v-deep .v-tooltip__content {
  background: rgba(0, 0, 0, 0.9) !important;
  border-radius: 6px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

::v-deep .v-card {
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.1) !important;
}

.text-danger {
  color: #e74c3c !important;
  font-weight: 800;
}

.text-grey-1 {
  color: #999 !important;
}
</style>